// extracted by mini-css-extract-plugin
module.exports = {"grafic":"swap_grafic__bPztG","swapSection":"swap_swapSection__13UXr","arrow":"swap_arrow__2K1T7","select":"swap_select__1MWBE"};